export class XmlRuleAttribut {
  public attribName: string;

  public required: boolean;

  /** when the values are from a given list **/
  public fixedValues: string[];

  public defaultValue: string;

  public xsdRawNode: Node;

  public typ: RuleAttributeTypes;

  public constructor(init?: Partial<XmlRuleAttribut>) {
    Object.assign(this, init);
    this.typ = this.getTyp();
  }

  getTyp(): RuleAttributeTypes {
    if (this.fixedValues && this.fixedValues.length > 0) {
      return RuleAttributeTypes.Enum;
    }
    return RuleAttributeTypes.String;
  }
}

export enum RuleAttributeTypes {
  String = 0,
  Enum = 1,
  Number = 2
}
